import { createMigration } from './utils';

enum Rotations {
    NINETY,
    MINUS_NINETY,
    ONE_EIGHTY,
    MINUS_ONE_EIGHTY,
    NOT_SUPPORTED
}

function approximatelyEqual(a: number, b: number, epsilon = 0.0001) {
    return Math.abs(a - b) < epsilon;
}

function getRotationCase(rotation: number): Rotations {
    if (approximatelyEqual(rotation, Math.PI / 2)) {
        return Rotations.NINETY;
    }
    if (approximatelyEqual(rotation, -Math.PI / 2)) {
        return Rotations.MINUS_NINETY;
    }
    if (approximatelyEqual(rotation, Math.PI)) {
        return Rotations.ONE_EIGHTY;
    }
    if (approximatelyEqual(rotation, -Math.PI)) {
        return Rotations.MINUS_ONE_EIGHTY;
    }
    return Rotations.NOT_SUPPORTED;
}

export const migrationTo9_208 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene, _isSceneDesign) {
        return scene.withMutations(map => {
            map.get('children', []).forEach((child, i) => {
                if (child.get('classType') !== 'TimeAwareMediaAsset') {
                    return;
                }

                const rotation = child.getIn(['transformation', 'rotation']);
                if (rotation === 0) {
                    return;
                }

                const width = child.getIn(['sourceData', 'width']);
                const height = child.getIn(['sourceData', 'height']);
                const x = child.getIn(['transformation', 'position', 'x']);
                const y = child.getIn(['transformation', 'position', 'y']);

                // there are a few designs that have a slight rotation, but don't account for a position change
                // so if that's the case we can just keep the position as is
                if (Math.abs(rotation) < 0.1 && x === 0 && y === 0) {
                    return;
                }

                // All other cases are either 90 or 180 degrees
                switch (getRotationCase(rotation)) {
                    case Rotations.NINETY:
                        // only need to update x
                        map.setIn(['children', i, 'transformation', 'position', 'x'], x - width);
                        break;
                    case Rotations.MINUS_NINETY:
                        map.setIn(['children', i, 'transformation', 'position', 'y'], y - height);
                        break;
                    case Rotations.ONE_EIGHTY:
                    case Rotations.MINUS_ONE_EIGHTY:
                        // need to update x & y
                        map.setIn(['children', i, 'transformation', 'position', 'x'], x - width);
                        map.setIn(['children', i, 'transformation', 'position', 'y'], y - height);
                        break;
                    case Rotations.NOT_SUPPORTED:
                        throw new Error(`Unsupported case to migrate rotation in ${scene.get('sceneDesign')}`);
                }
            });
        });
    },
});
